<script setup>
import {useRouter} from '@/core/plugins/router';

const {route} = useRouter();
const ChartComponent = route.value.component;
</script>

<template>
    <div class="issuies-board-wrapper relative">
        <ChartComponent />
    </div>
</template>
